import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildVenueExecCapsuleConfigSlice } from './config/configslice';
import { VenueAnalysisCapsuleState } from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleState';
import { VenueAnalysisCapsuleActionPayload } from 'widgets/venueAnalysis/capsules/store/actions';

const { reducer: configReducer } = buildVenueExecCapsuleConfigSlice();

const venueExecCapsuleWidgetReducer =
    combineReducers<VenueAnalysisCapsuleState>({
        config: configReducer,
    });

export const venueExecCapsuleWidgetsReducer = createWidgetsReducer<
    VenueAnalysisCapsuleState,
    VenueAnalysisCapsuleActionPayload
>(WidgetType.VENUE_EXEC_CAPSULE, venueExecCapsuleWidgetReducer);
